import script from "./UserDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetailView.vue?vue&type=script&setup=true&lang=js"

import "./UserDetailView.vue?vue&type=style&index=0&id=8eb368c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8eb368c0"]])

export default __exports__